import { Fragment, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { useFormData } from '../../../contexts/FormData';

import { useFormikContext } from 'formik';

import { Box, Chip, Grid, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';

import { BasicFlex } from '../../../utils/Common';

import { formatGenericDate } from '../../../utils/util';

import Field from '../../../utils/FormikFields/Field';

import RequestItems from './RequestItems';
import UploadDocument from './UploadDocument';

const Container = styled.div`
  margin: 2rem 0;
`;

const Hint = styled(Typography)`
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.2;
  opacity: 0.75;
  text-transform: none;
  letter-spacing: 0;
`;

const toggleSx = {
  flexDirection: 'column',
  alignItems: 'center',
  gap: 0.5,
  py: 1.25,
  textTransform: 'none',
  lineHeight: 1.2,
};

const UploadMethod = () => {
  const { formValues, setFormValues } = useFormData() || {};
  const { values } = useFormikContext() || {};

  let isEdit = values?.shipment_id ? true : false;

  const handleToggle = (val) => {
    setFormValues({ ...formValues, entry: val });
  }

  return (
    <Grid size={{ xs: 12 }}>
      {!isEdit ? <ToggleButtonGroup
        size="small"
        color="secondary"
        value={formValues.entry}
        onChange={(e, val) => val && handleToggle(val)}
        exclusive
        fullWidth
      >
        <ToggleButton value="manual" sx={toggleSx}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <EditOutlinedIcon fontSize="small" />
            Manual Entry
          </Box>
          <Hint>Add each wig yourself</Hint>
        </ToggleButton>

        <ToggleButton value="upload" sx={toggleSx}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <AutoAwesomeOutlinedIcon fontSize="small" />
            Upload Document
            <Chip
              label="Beta"
              size="small"
              color="secondary"
              variant="outlined"
              sx={{
                height: 18,
                fontSize: 10,
                fontWeight: 700,
                letterSpacing: 0.4,
                '& .MuiChip-label': { px: 0.75 },
              }}
            />
          </Box>
          <Hint>AI reads your packing list — check before saving</Hint>
        </ToggleButton>
      </ToggleButtonGroup> : null}

      <Container>
        {formValues?.entry === 'manual' && <RequestItems />}
        {formValues?.entry === 'upload' && <UploadDocument />}
      </Container>
    </Grid>
  );
};

export default UploadMethod;